import { useGetIdentity } from "@refinedev/core";
import type { AppUser } from "types";

export const useAuth = () => {
  const { data: dataIdentity } = useGetIdentity<AppUser>();
  const accessToken = dataIdentity?.token?.access_token;

  return { accessToken };
};
